// @flow
import filesize from "file-size";

import type { IConstraintModel, FilesizeConstraintsType } from "../../types";

const MAX_TOTAL_FILE_SIZE_ID = "Constraint.File.MaxTotalFileSize";
const MAX_FILE_SIZE_ID = "Constraint.File.MaxFileSize";

/**
 */
class FileSizeConstraint implements IConstraintModel {
  _filesizeConstraint: FilesizeConstraintsType;

  /**
   */
  constructor(filesizeConstraint: FilesizeConstraintsType) {
    this._filesizeConstraint = filesizeConstraint;
  }

  /**
   */
  get id(): string {
    if (this.filesizeConstraint.isMaxTotal) {
      return MAX_TOTAL_FILE_SIZE_ID;
    } else if (this.filesizeConstraint.fileSize !== undefined) {
      return MAX_FILE_SIZE_ID;
    }

    return "";
  }

  /**
   */
  get filesizeConstraint(): FilesizeConstraintsType {
    return this._filesizeConstraint;
  }

  /**
   */
  hasValidation(): boolean {
    return false;
  }

  /**
   */
  get defaultMessage(): string {
    if (this.id === MAX_TOTAL_FILE_SIZE_ID) {
      return "{filesize-left} van {max-total-filesize} over van totaal toegestaan upload bestandsgrootte"; // NOSONAR
    } else if (this.id === MAX_FILE_SIZE_ID) {
      return "Maximale bestandsgroote is ${max-filesize}"; // NOSONAR
    }

    return "";
  }

  /**
   */
  get filesize(): any {
    return filesize(this.filesizeConstraint.fileSize).human("jedec");
  }

  /**
   */
  get maxTotalFileSize(): any {
    return filesize(this.filesizeConstraint.maxTotalFileSize).human("jedec");
  }

  /**
   */
  get parameters():
    | { ... }
    | { "filesize-left": any, "max-total-filesize": any }
    | { "max-filesize": any } {
    if (this.id === MAX_TOTAL_FILE_SIZE_ID) {
      return {
        "filesize-left": this.filesize,
        "max-total-filesize": this.maxTotalFileSize,
      };
    } else if (this.id === MAX_FILE_SIZE_ID) {
      return {
        "max-filesize": this.filesize,
      };
    }

    return {};
  }

  /**
   */
  validate(): boolean {
    return true;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default FileSizeConstraint;
